<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit,
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :xxl="4" :xs="6">
              <s-input
                title="标题"
                :labelCol="6"
                :valueCol="16"
                v-model:value="queryParams.Title"
              />
            </a-col>
            <a-col>
              <a-button type="primary" @click="getDataList(1)">查询</a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="addForm(() => $refs.eForm.open(null))"
              >
                添加
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.id"
          :scroll="{ y: height, x: width }"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'index'">
              {{ (page.page - 1) * queryParams.Limit + index + 1 }}
            </template>

            <template v-if="column.key === 'publishTime'">
              {{ $filters.formatDate(record.publishTime, 'YYYY-MM-DD HH:mm') }}
            </template>

            <template v-if="column.key === 'isHomeShow'">
              <a-switch
                v-model:checked="record.isHomeShow"
                checked-children="显示"
                un-checked-children="隐藏"
                @change="changeIsHomeShow(record.id, $event)"
              />
            </template>

            <template v-if="column.key === 'department'">
            <div>{{record.department? record.department.name: ''}}</div>
          </template>

            <template v-if="column.key === 'isTop'">
              <a-switch
                v-model:checked="record.isTop"
                :checkedValue="1"
                :unCheckedValue="0"
                checked-children="置顶"
                un-checked-children="取消"
                @change="changeIsTop(record.id, $event)"
              />
            </template>

            <template v-if="column.key === 'publishStatus'">
              <a-switch
                v-model:checked="record.publishStatus"
                :checkedValue="1"
                :unCheckedValue="0"
                checked-children="显示"
                un-checked-children="隐藏"
                @change="changeStatus(record.id, $event)"
              />
            </template>

            <template v-if="column.key === 'action'">
              <a-tooltip>
                <template #title>编辑</template>
                <a @click.stop="editForm(() => $refs.eForm.open(record))">
                  <EditOutlined />
                </a>
              </a-tooltip>
              <a-divider type="vertical" />
              <a-tooltip>
                <template #title>删除</template>
                <a @click.stop="delForm(() => delFormFun(record))"
                  ><DeleteOutlined
                /></a>
              </a-tooltip>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>

    <EForm ref="eForm" @ok="getDataList(1)" />

  </div>
</template>

<script>
import { defineComponent, ref, createVNode } from 'vue'
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
import { NewsClass } from '@/apis/news'
import page from '@/mixins/page'

import EForm from '@/components/forms/news/Form'

const api = new NewsClass()
export default defineComponent({
  mixins: [page],
  components: {
    EditOutlined,
    DeleteOutlined,
    EForm
  },
  setup () {
    const loading = ref(false)
    const height = ref(500)
    const width = ref(500)

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 60
      },
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 300
      },
      {
        title: '标识',
        dataIndex: 'sign',
        key: 'sign',
        width: 120
      },
      {
        title: '类型',
        dataIndex: 'newsTypeName',
        key: 'newsTypeName',
        width: 100
      },
      {
        title: '区域',
        dataIndex: 'department',
        key: 'department',
        width: 100
      },
      {
        title: '置顶',
        dataIndex: 'isTop',
        key: 'isTop',
        width: 100
      },
      {
        title: '发布状态',
        dataIndex: 'publishStatus',
        key: 'publishStatus',
        width: 100
      },
      {
        title: '发布时间',
        dataIndex: 'publishTime',
        key: 'publishTime',
        width: 160
      },
      {
        title: '用户',
        dataIndex: 'publisherName',
        key: 'publisherName',
        width: 100
      },
      {
        title: '点赞量',
        dataIndex: 'like',
        key: 'like',
        width: 80
      },
      {
        title: '阅读次数',
        dataIndex: 'readTimes',
        key: 'readTimes',
        width: 80
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 100,
        fixed: 'right'
      }
    ]
    return {
      columns,
      loading,
      height,
      width
    }
  },
  created () {
    this.getDataList(1)
  },
  methods: {
    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit
      q.IsDelete = false
      q.DepartmentId = this.$store.state.user.userInfo.departmentId
      api.gets(q).then((resp) => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 20
      }

      this.getDataList(1)
    },
    delFormFun (record) {
      const _this = this
      _this.$confirm({
        title: '确定删除?',
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode(
          'div',
          {
            style: 'color:red;'
          },
          `即将删除数据：${record.title}`
        ),

        onOk () {
          api.del(record.id).then(() => {
            _this.$message.success('删除成功！')
            _this.getDataList(1)
          })
        }
      })
    },
    changeIsTop (id, e) {
      this.loading = true
      api.top(id, e).then(() => {
        this.$message.success('设置成功！')
        this.getDataList(this.page.page)
      })
    },

    changeIsHomeShow (id, e) {
      this.loading = true
      api.home(id, e).then(() => {
        this.$message.success('设置成功！')
        this.getDataList(this.page.page)
      })
    },

    changeStatus (id, e) {
      this.loading = true
      api.status(id, e).then(() => {
        this.$message.success('设置成功！')
        this.getDataList(this.page.page)
      })
    },

    changeAudio (e) {
      api.audio(e.id).then(() => {
        this.$message.success('正在转音频，请稍后刷新！')
        this.getDataList(this.page.page)
      })
    },

    playAudio (e) {
      window.open(e)
    },

    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    },

    okForm (e) {
      this.getDataList(1)
    }
  }
})
</script>

<style lang="less" scoped></style>
